export default __webpack_public_path__ + "static/media/klapka.c9b05065.png";